const BASE_ROUTE = "/embeddables";

export const EMBEDDABLES_ROUTE = {
  BASE: BASE_ROUTE,
  ACCOUNT: `${BASE_ROUTE}/account`,
  SCHEDULE_APPOINTMENT: `${BASE_ROUTE}/schedule-appointment`,
  SUCCESS: `${BASE_ROUTE}/start-your-journey`,
} as const;
